///////////////////////////
///////////////
//////////

// Polyfills
// import objectFitImages from "object-fit-images";
// import objectFitVideos from "object-fit-videos";

// objectFitImages();
// objectFitVideos();

// import "picturefill";
// import lazySizes from "lazysizes";

// import "details-polyfill";

require("./old/index.js");
import axios from "axios";
import Vue from "vue";
import store from "./checkout/store";
import AddToBasketButton from "./checkout/AddToBasketButton";
import AddSubProductToBasketButton from "./checkout/AddSubProductToBasketButton";
import AddBookingToBasketButton from "./checkout/AddBookingToBasketButton";
import BasketButton from "./checkout/BasketButton";
import MiniBasket from "./checkout/MiniBasket";
import Checkout from "./checkout/Checkout";
import CheckoutBlock from "./checkout/CheckoutBlock";
import CheckoutBlockHeader from "./checkout/CheckoutBlockHeader";
import CheckoutBlockBody from "./checkout/CheckoutBlockBody";
import Spinner from "./checkout/Spinner";
import Modal from "./checkout/Modal";
import ExpiredReservations from "./checkout/ExpiredReservations";
import BasketClearedByError from "./checkout/BasketClearedByError";

export const bus = new Vue();

Vue.component("CheckoutBlock", CheckoutBlock);
Vue.component("CheckoutBlockHeader", CheckoutBlockHeader);
Vue.component("CheckoutBlockBody", CheckoutBlockBody);
Vue.component("Spinner", Spinner);
Vue.component("Modal", Modal);

Vue.filter("toCurrency", function(value) {
	if (typeof value !== "number") {
		return value;
	}
	var formatter = new Intl.NumberFormat("da-DK", {
		style: "currency",
		currency: "DKK",
		minimumFractionDigits: 0
	});
	return formatter.format(value);
});

window.checkoutApp = new Vue({
	el: "#vue-app",
	store,
	data: {
		currentRoute: window.location.hash
	},
	components: {
		AddToBasketButton,
		AddSubProductToBasketButton,
		AddBookingToBasketButton,
		BasketButton,
		MiniBasket,
		Checkout,
		CheckoutBlock,
		CheckoutBlockHeader,
		CheckoutBlockBody,
		ExpiredReservations,
		BasketClearedByError
	},
	created() {
		this.$store.dispatch("loadBasket");
		this.$store.dispatch("updateBasket");
	}
});

window.addEventListener("pageshow", (event) => {
	console.log("pageshow");
	window.checkoutApp.$store.dispatch("setRoute", event.target.location.hash);
});

window.addEventListener("popstate", (event) => {
	console.log("popstate");
	if (event && event.state && event.state.shouldReload === true) {
		window.location.reload();
	}
	window.checkoutApp.$store.dispatch("setRoute", window.location.hash);
});

window.addEventListener("error", (msg, url, line) => {
	axios
	.post("/umbraco/api/Log/LogError", {
		"exception": msg.message,
		"data": {stack: msg.error.stack, file: msg.error.fileName, url: window.location.href},
		"method": "JavascriptException"
	});
});
